//These are little helpers used throughout the site
//If the window is at least tablet size according to Bulma
export let isSize = {
    data: () => ({
        window: {
            width: 0,
        }
    }),
    computed: {
        isTablet() {
            return this.window.width > 768;
        },
        isDesktop() {
            return this.window.width > 1023;
        },
    },
    created() {
        //Needed because resize does NOT trigger re-compute
        window.addEventListener('resize', () => this.window.width = window.innerWidth);
        this.window.width = window.innerWidth;
    },
};
